import { RecommendeeType } from '@app/recommendations/recommendations.model';

export const addUserProfileKeyToUser = <
  T extends { resourceId?: number; resourceType?: RecommendeeType | string },
>(
  item: T
): T & { userProfileKey?: number } => ({
  ...item,
  ...(item.resourceType === 'User' && {
    userProfileKey: item.resourceId,
  }),
});
